import React from "react";
import styles from "./AppMenuSection.module.css";
import { AccordionItem, AccordionHeader, AccordionPanel } from "../ui/Accordion";

export default function AppMenuSection({
  value,
  title = "",
  children,
  className = "",
}) {
  return (
    <AccordionItem value={value} className={[styles.section, className].join(" ")}>
      {title ? (
        <AccordionHeader className={styles.title}>
          <span className={styles.titleText}>{title}</span>
        </AccordionHeader>
      ) : null}
      <AccordionPanel className={styles.panel}>
        <div className={styles.content}>{children}</div>
      </AccordionPanel>
    </AccordionItem>
  );
}